





import { Component, Vue, Prop } from 'vue-property-decorator';

import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { VBTooltip } from 'bootstrap-vue';

@Component({
  name: 'InfoTooltip',
  components: {
    AgroIcon: AgroIcons,
  },
  directives: {
    BTooltip: VBTooltip,
  },
})
export default class InfoTooltip extends Vue {
  @Prop(String)
  private title!: string;

  @Prop({ type: [Number, String], required: false, default: 16 })
  private iconSize!: number | string; 

  @Prop({ type: String, required: false, default: '#888' })
  private iconColor!: string; 

  @Prop({ type: String, required: false, default: null })
  private iconClass!: string | null;

  @Prop({ type: String, required: false, default: 'auto' })
  private tooltipPlacement!: string;
}
